module.exports = __webpack_public_path__ + "static/media/back-winner.70d1fb03.png";